import z from 'zod';

export const userInfoSchema = z.object({
    expiresAt: z.iso.datetime(),
});
export type UserInfo = z.infer<typeof userInfoSchema>;
